import axios from 'axios'
import store from '@/store'

const instance = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  timeout: 90000,
  headers: {
    'Content-Type': 'application/json',
  }
})
// Identifica este dispositivo (móvil, navegador del PC…): cada uno lleva sus recogidas sin enviar y el DeCA
// las suma sin pisarse (docs/specs/deca.md §14.9).
const dispositivoId = () => {
  try {
    let id = localStorage.getItem('gecotrail-dispositivo')
    if (!id) {
      id = crypto.randomUUID()
      localStorage.setItem('gecotrail-dispositivo', id)
    }
    return id
  } catch (e) {
    return null
  }
}

console.log('2009',instance);

instance.interceptors.request.use(
  config => {
    const token = store.getters['auth/token']
    const conductor = store.getters['auth/conductor']

    if (conductor){     
      config.headers['Conductor'] = conductor
    }

    const dispositivo = dispositivoId()
    if (dispositivo) {
      config.headers['X-Dispositivo'] = dispositivo
    }

    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`
    }
  
    return config
  }
)

export default instance
